/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  tk: null,
  username: null,
  id: null,
  error: null,
  loading: false,
  awaitingConfirmation: false,
  userDetails: null,
  isAuthenticated: false,
  authChecked: false,
};

const authStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const authSuccess = (state, action) => {
  let props = updateObject(state, {
    tk: action.user.tk,
    username: action.user.username,
    id: action.user.id,
    error: null,
    loading: false,
    ext: action.ext,
    userDetails: action.user.userDetails,
    isAuthenticated: true,
    authChecked: true,
  });
  return props;
};

const authFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    tk: null,
    isAuthenticated: false,
    authChecked: false,
  });
};

const authSignout = (state, action) => {
  return updateObject(state, {
    tk: null,
    isAuthenticated: false,
    authChecked: false,
  });
};

function confirmUser(state, action) {
  return updateObject(state, {
    error: null,
    loading: false,
    awaitingConfirmation: true,
  });
}

function userConfirmed(state, action) {
  return updateObject(state, {
    error: null,
    loading: false,
    awaitingConfirmation: false,
  });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_SIGNOUT:
      return authSignout(state, action);
    case actionTypes.CONFIRM_USER:
      return confirmUser(state, action);
    case actionTypes.USER_CONFIRMED:
      return userConfirmed(state, action);
    case actionTypes.AUTH_CHECK_DONE:
      return updateObject(state, { authChecked: true });
    default:
      return state;
  }
};

export default reducer;
